module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_cart.0b8ae07f.svg";